module.exports = __webpack_public_path__ + "static/media/md-paper.9aa1466b.svg";